import { useState, useEffect } from 'react';
import useTeamMembersQuery from './useTeamMembersQuery';

const useTeamUsers = ({ team, enabled = false }) => {
  const [members, setMembers] = useState([]);
  const {
    members: fetchedMembers,
    isLoading,
    error
  } = useTeamMembersQuery({ team, enabled });

  useEffect(() => {
    setMembers(fetchedMembers);
  }, [fetchedMembers]);

  return {
    members,
    setMembers,
    isLoading,
    error
  };
};

export default useTeamUsers;
